import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { I18n } from 'common'
import { Select } from '../../../ui-components'
import { Vehicle } from '../../../store/models/Vehicles'
import { ShoppingCart } from '@mui/icons-material'
import { defaultTheme } from '../../../theme'
import { IdValueGeneric } from 'interfaces'
import { formatVehicleDisplay } from 'src/helpers/utils'

interface Props {
  carts: Vehicle[]
  selectedCart: Vehicle
  onChange: (vehicle: Vehicle) => void
  dropDownRef: React.RefObject<HTMLInputElement>
}

const CartDropdown = (props: Props): ReactElement => {
  const { carts, selectedCart, onChange, dropDownRef } = props

  const cartName = (v: Vehicle) => formatVehicleDisplay(v)

  const options = carts?.map((v) => ({ id: v.id, value: cartName(v) }))
  const selectedOption = options?.find((o) => o.id === selectedCart.id)

  const handleOnChange = (
    selected: IdValueGeneric<string | number, string>
  ): void => {
    const selectedVehicle = carts.find((c) => c.id === selected.id)
    onChange(selectedVehicle)
  }

  return (
    <FlexColumn>
      <Title>
        <I18n name="selectACart" />
      </Title>
      <Instructions>
        <I18n name="youHaveMultipleOpenCartsInYourShoppingCart" />
        {'. '}
        <I18n name="selectTheCartYouWantToAddItemsTo" />.
      </Instructions>
      <Select
        options={options}
        selectedOption={selectedOption}
        onSelect={handleOnChange}
        icon={<ShoppingCartIcon />}
        optionsBoxRef={dropDownRef}
      />
    </FlexColumn>
  )
}

export default CartDropdown

const Flex = styled.div`
  display: flex;
`

const FlexColumn = styled(Flex)`
  flex-direction: column;
`

const Title = styled.p`
  font-family: Oswald;
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: 0px;
`

const Instructions = styled.p`
  font-family: Roboto;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0px;
`

const ShoppingCartIcon = styled(ShoppingCart)`
  color: ${defaultTheme.colors.greyDark};
`
